var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphoneAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.8983C3 5.98391 7.02944 2 12 2C16.9706 2 21 5.98391 21 10.8983V14H20.9906C20.9968 14.0944 21 14.1897 21 14.2857V14.7143C21 16.3581 20.0746 17.7857 18.7163 18.5046C18.4699 20.337 16.9 21.75 15 21.75H13.7993C13.54 22.1984 13.0552 22.5 12.5 22.5H11.5C10.6716 22.5 10 21.8284 10 21C10 20.1716 10.6716 19.5 11.5 19.5H12.5C13.0552 19.5 13.54 19.8016 13.7993 20.25H15C15.8877 20.25 16.6554 19.7359 17.0215 18.9892C16.92 18.9963 16.8176 19 16.7143 19C15.7675 19 15 18.2325 15 17.2857V11.7143C15 10.7675 15.7675 10 16.7143 10C17.7576 10 18.7139 10.3728 19.4571 10.9925V10.8983C19.4571 6.82638 16.1185 3.52542 12 3.52542C7.88153 3.52542 4.54286 6.82638 4.54286 10.8983V10.9925C5.28609 10.3728 6.24236 10 7.28571 10C8.23249 10 9 10.7675 9 11.7143V17.2857C9 18.2325 8.23249 19 7.28571 19C4.91878 19 3 17.0812 3 14.7143V14.2857C3 14.1897 3.00316 14.0944 3.00937 14H3V10.8983Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneAlt);
export default __webpack_public_path__ + "static/media/headphone-alt.a9e207153c0330f0c4542e7758a48694.svg";
export { ForwardRef as ReactComponent };